import React from "react";

type UserIconProps = React.SVGProps<SVGSVGElement>;

export const UserIcon = ({
  width = 20,
  height = 20,
  ...props
}: UserIconProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.9998 8.99961C11.6566 8.99961 12.9996 7.65655 12.9996 5.9998C12.9996 4.34306 11.6566 3 9.9998 3C8.34306 3 7 4.34306 7 5.9998C7 7.65655 8.34306 8.99961 9.9998 8.99961Z" stroke="#253858" stroke-width="1.5"/>
    <path d="M16 14.5C16 16.4328 16 18 10 18C4 18 4 16.4328 4 14.5C4 12.5672 6.6865 11 10 11C13.3135 11 16 12.5672 16 14.5Z" stroke="#253858" stroke-width="1.5"/>
    </svg>
    
    
  
);

export default UserIcon;
